<template>
    <div class="lovemap-container-resize">
        <l-map
                ref="map"
                class="love-map-canvas"
                :zoom="zoomValue"
                :center="center"
                :options="{
                       zoomControl: false,
                       gestureHandling: true
                }"
                @update:zoom="zoomUpdated"
                @update:center="centerUpdated"
        >
            <TxTileLayer v-if="isWebGlEnabled" :template-name="mapStyle"/>
            <l-tile-layer v-else :url="mapTileServer"/>
        </l-map>
    </div>
</template>

<script>
    import {LMap, LTileLayer} from 'vue2-leaflet';
    import "leaflet-gesture-handling";
    import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

    import CityMapModule from '../store-mixin'

    export default {
        name: 'CityMap',
        mixins: [CityMapModule()],
        watch: {
            mapSize: 'prepareMap',
            mapLayout: 'prepareMap',
        },
        components: {
            LMap,
            LTileLayer,
        },
        mounted() {
            this.prepareMap();
        },
        created() {
            window.addEventListener('resize', this.onResizeEnd, {passive: true});
        },
        methods: {
            prepareMap() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs?.polyline?.mapObject?.bringToFront();
                        this.$refs.map.mapObject.invalidateSize();
                    }, 400)
                })
            },
            onResizeEnd(event) {
                this.$refs.map.mapObject.invalidateSize();
                this.$refs.map.mapObject.getCenter();
            },
            zoomUpdated(zoom) {
                this.zoom = zoom;
            },
            centerUpdated(center) {
                this.center = Object.values(center);
            },
        },
        computed: {
            zoomValue(){
                return Number(this.zoom)
            },
            mapTileServer(){

                let tileConfig = {
                    lovemap: this.url,
                    'city-map': this.citymap_tile_url,
                    osm: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
                };

                return tileConfig[this.mapStyle]
            },
            isWebGlEnabled(){
                return this.$root.lovemap.webgl !== 'false'
            },
            url() {
                return `${lovemap.config.tile_url}`
            },
            citymap_tile_url() {
                return `${lovemap.config.citymap_tile_url}`
            },
        },
    }
</script>

<style lang="scss">

    .leaflet-control-attribution {
        &.leaflet-control {
            display: none;
        }
    }

    .lovemap-container-resize {
        width: 100%;
        height: 100%;
    }

    .love-map-canvas {
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .leaflet-overlay-pane {
        z-index: 4000;
    }
</style>

